import CarList from "./car/carList.vue";
import CarDetail from "./car/carDetail.vue";

import salePassatPay from "./pay/pay.vue";
import PaySucc from "./pay/paySucc.vue";

import OrderList from "./order/orderList.vue";
import OrderDetail from "./order/orderDetail.vue";

import GetCouponCode from "./exchangeCode/getCouponCode.vue";
import ExchangeCouponCode from "./exchangeCode/exchangeCouponCode.vue";

import CouponList from "./coupon/couponList.vue";
import CouponDetail from "./coupon/couponDetail.vue";

const router = [
    {
        path: "/salePassat/",
        name: "carList",
        component: CarList,
        meta: {
            title: "车辆列表",
        },
    },{
        path: "/salePassat/carList",
        name: "carList",
        component: CarList,
        meta: {
            title: "车辆列表",
        },
    },{
        path: "/salePassat/carDetail/:id",
        name: "carDetail",
        component: CarDetail,
        meta: {
            title: "车辆详情",
        },
    },{
        path: "/salePassat/pay",
        name: "salePassatPay",
        component: salePassatPay,
        meta: {
            title: "支付",
        },
    },{
        path: "/salePassat/paySucc",
        name: "paySucc",
        component: PaySucc,
        meta: {
            title: "支付成功",
        },
    },{
        path: "/salePassat/orderList",
        name: "orderList",
        component: OrderList,
        meta: {
            title: "订单列表",
        },
    },{
        path: "/salePassat/orderDetail/:orderId",
        name: "orderDetail",
        component: OrderDetail,
        meta: {
            title: "订单详情",
        },
    },{
        path: "/salePassat/getCoupon/:orderId",
        name: "getCouponCode",
        component: GetCouponCode,
        meta: {
            title: "我的权益",
        },
    },{
        path: "/salePassat/exchangeCouponCode",
        name: "exchangeCode",
        component: ExchangeCouponCode,
        meta: {
            title: "兑换优惠券",
        },
    },{
        path: "/salePassat/couponList",
        name: "couponList",
        component: CouponList,
        meta: {
            title: "优惠券列表",
        },
    },{
        path: "/salePassat/couponDetail/:id",
        name: "couponDetail",
        component: CouponDetail,
        meta: {
            title: "优惠券详情",
        },
    },
];

export default router;



// WEBPACK FOOTER //
// src/pages/saleCar/router-config.js